import React from 'react';
import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { remove, findIndex, forEach, find } from 'lodash';
import {isMobileOnly} from 'react-device-detect';
import EsOrderBrListItem from './EsOrderBrListItem';
import AnimateHeight from 'react-animate-height';

const EsOrderBrListBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 20px;
    `:`
    margin: 0px 21px 30px 19px;
    `};

    //padding: 0 16px;
    border-radius: 4px;
    border: solid 1px #cccccc;
`;

const EsOrderBrListHeaderBlock = styled.div`
    ${isMobileOnly?`
    height: 96px; 
    `:`
    height: 64px;
    //border-top: 2px solid #111111;
    //border-bottom: 1px solid #cccccc;
    `};

    position: relative;
    padding: 18px 16px 0;
`;

const EsOrderBrListHeaderLineBlock = styled.div`
    height: 1px;
    background-color: #cccccc;
    margin: 0 16px;
`;

const EsOrderBrListHeaderBrandBlock = styled.div`
    ${isMobileOnly?`
    float: left;
    line-height: 24px;
    margin-right: 10px;
    font-size: 14px;
    `:`
    float: left;
    line-height: 30px;
    //margin-left: 36px;
    margin-right: 10px;
    font-size: 16px;
    font-weight: 500;
    `};

    font-weight: 500;
    color: #333333;
    
`;

const EsOrderBrListHeaderExpireBlock = styled.div`
    ${isMobileOnly?`
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    margin-top: 20px;
    `:`
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    margin-top: 20px;
    `};

    text-align: left;
    color: #cccccc;
    padding: 0 16px;
`;

const EsOrderBrListHeaderPckgBlock = styled.div`
    ${isMobileOnly?`
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: left;
    margin-top: 4px;
    `:`
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: left;
    margin-top: 4px;
    `};

    text-align: left;
    color: #333333;
    padding: 0 16px;
`;

const EsOrderBrListHeaderDeliveryBlock = styled.div`
    ${isMobileOnly?`
    font-size: 13px; 
    margin-top: 34px;
    width: fit-content; 
    padding: 2px 16px;
    `:`
    font-size: 13px;
    line-height: 24px;
    float: left;
    margin-top: 2px;
    padding: 0 16px;
    `};
    
    font-weight: 500;
    
    border-radius: 13px;
    border: solid 1px #79b88a;
    color: #79b88a;
    height: 26px;
    
    ::before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 13px;
        margin-right: 8px;
        background: url(/assets/images/icon/truck.svg) center center/auto no-repeat;
        ${isMobileOnly?`
        vertical-align: -4px; 
        `:`
        vertical-align: -2px;
        `};
        
    }
`;

const EsOrderBrListHeaderArrowSpanBlock = styled.span`
    ${isMobileOnly?`
    padding-top: 0px;
    padding-bottom: 20px;
    width: 17px; 
    `:`
    padding-top: 8px;
    padding-bottom: 20px;
    width: 60px;
    `};

    float: right;
    
    //height: 70px;
    background: url(/assets/images/icon/da-icon.png) center center/auto no-repeat;

    &.active {
        background: url(/assets/images/icon/da-icon-active.png) center center/auto no-repeat;
    }
`;



const EsOrderBrBottomBlcok = styled.div`
    ${isMobileOnly?`
    margin-top: 0px;
    min-height: 46px;
    `:`
    margin-top: 30px;
    height: 60px;
    `};

    
    background-color: #f4f4f4;
    position: relative;
    
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
`;

const EsOrderBrBottomContentsBlcok = styled.div`
    float: right;

    ${isMobileOnly?`
    padding: 0 16px;
    `:`
    padding: 0 36px;
    `};

    .won {
        ${isMobileOnly?`
        font-size: 14px;
        `:`
        font-size: 16px;
        `};

    font-weight: normal;
    }
    .sign {
        padding: 0 10px;
    }
    .es_price {
    color: #111111;
    font-weight: 600;
    float: right;
    }

`;

const EsOrderBrBottomContentsSpanBlcok = styled.div`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 1.71;
    padding-top: 12px;
    `:`
    font-size: 18px;
    line-height: 1.33;
    padding-top: 19px;
    `};

    float: left;
    
    font-weight: 500;
    color: #333333;
`;

const EsOrderBrBottomBlankBlock = styled.div`
    height: 30px;
`;

const EsOrderBrList = ({item}) => {
    const [open, setOpen] = useState(true);
    const [normalPrice, setNormalPrice] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const priceRef = useRef(null);

    useEffect(() => {
        let tPrice = 0; //할인된 상품 금액
        let sPrice = 0; //상품 할인 금액
        let nPrice = 0; //정상 상품 가격
        let count = 0;
        if( item !== null && item !== undefined && item.list !== null){


            forEach(item.list, (curobj, index) => {
                let nPrice2 = curobj.prdct_price*1*curobj.qty*1;
                let tPrice2 = curobj.es_opt_pirce*1*curobj.qty*1;
                if(curobj.sale_price === curobj.prdct_price) {
                    nPrice2 = tPrice2;
                }
                nPrice += nPrice2;
                tPrice += tPrice2;
                count++;
            });
        }
        //setCountCheck(count);
        setTotalPrice(tPrice);
        setNormalPrice(nPrice);
        sPrice = nPrice - tPrice;
        setSalePrice(sPrice);

    }, [item])
    
    

    const handleOpen = () => {
        setOpen(!open);
    }

    const getDlvryPrice = () => {

        // 선불
        if (item.list[0].es_dlvry_final_pay_type === '025201') {
            return (<p className='f-right'>선불 배송비<span> {Number(item.list[0].es_dlvry_total_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else if (item.list[0].es_dlvry_final_pay_type === '025202') { // 착불
            return (<p className='f-right'>예상 착불 배송비<span> {Number(item.list[0].es_dlvry_total_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return (<p className='f-right'>무료배송</p>)
        }
    }

    if(item === null || item === undefined || item.list === null || item.list.length < 1) {
        return <div/>
    }

    
    return (
        <EsOrderBrListBlock >
            {
                isMobileOnly?
                <EsOrderBrListHeaderBlock className="clearfix" onClick={handleOpen}>
                    <EsOrderBrListHeaderBrandBlock className="clearfix">{item.list[0].brnd_han}</EsOrderBrListHeaderBrandBlock>
                    
                    <EsOrderBrListHeaderArrowSpanBlock className={open? "active":"none"}/>
                    <EsOrderBrListHeaderDeliveryBlock>{getDlvryPrice()}</EsOrderBrListHeaderDeliveryBlock>
                </EsOrderBrListHeaderBlock>
                :
                <EsOrderBrListHeaderBlock className="clearfix" onClick={handleOpen}>
                    <EsOrderBrListHeaderBrandBlock className="clearfix">{item.list[0].brnd_han}</EsOrderBrListHeaderBrandBlock>
                    <EsOrderBrListHeaderDeliveryBlock>{getDlvryPrice()}</EsOrderBrListHeaderDeliveryBlock>
                    <EsOrderBrListHeaderArrowSpanBlock className={open? "active":"none"}/>
                </EsOrderBrListHeaderBlock>
            }
            
            
            <AnimateHeight duration={300} height={(open ? 'auto' : '0')} className="clearfix">
            <EsOrderBrListHeaderLineBlock />
            <EsOrderBrListHeaderExpireBlock >주문 유효기간 : {item.list[0].expr_date}</EsOrderBrListHeaderExpireBlock>
            <EsOrderBrListHeaderPckgBlock >{item.list[0].pckg_nm}</EsOrderBrListHeaderPckgBlock>
            {
                item.list.map((prod, idx) => {
                    return <EsOrderBrListItem key={prod.prdct_id} item={prod}/>
                })
            }
            {isMobileOnly&&<EsOrderBrBottomBlankBlock/>}
            </AnimateHeight>
            <EsOrderBrBottomBlcok className="clearfix">
                <EsOrderBrBottomContentsBlcok>
                    <EsOrderBrBottomContentsSpanBlcok>{Number(item.list[0].es_prdct_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span><span className="sign">-</span> </EsOrderBrBottomContentsSpanBlcok>
                    <EsOrderBrBottomContentsSpanBlcok> {Number(item.list[0].es_dscnt_total_price.toFixed(1)).toLocaleString()}<span className="won">원</span><span className="sign">=</span> </EsOrderBrBottomContentsSpanBlcok>
                    <EsOrderBrBottomContentsSpanBlcok className="es_price"> {Number(item.list[0].es_final_price.toFixed(1)).toLocaleString()}<span className="won">원</span> </EsOrderBrBottomContentsSpanBlcok>
                </EsOrderBrBottomContentsBlcok>
            </EsOrderBrBottomBlcok>
        </EsOrderBrListBlock>
    );
};

export default EsOrderBrList;